export default __webpack_public_path__ + "static/media/Rice and Egg.108d6b48.png";